import { observer } from "mobx-react-lite";
import { Layer, Source } from "react-map-gl";
import { useMapStore } from "../..";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function SatelliteBingBaseMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    const mapStore = useMapStore();
    if (!(isStyleLoadedOverride ?? mapStore.isStyleLoaded))
        return null;

    return (
        <Source id="satelliteBingBaseMapSource" type="raster" tiles={[
            "https://ecn.t0.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=587&mkt=en-gb&n=z",
            "https://ecn.t1.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=587&mkt=en-gb&n=z",
            "https://ecn.t2.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=587&mkt=en-gb&n=z",
            "https://ecn.t3.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=587&mkt=en-gb&n=z",
        ]} tileSize={256}>
            <Layer
                id="satelliteBingBaseMapLayer"
                type="raster"
                slot="top"
                beforeId="mapbox-satellite"
                layout={{
                    "visibility": visible ? "visible" : "none",
                }}
            />
        </Source>
    );
}

export default observer(SatelliteBingBaseMapLayer);